var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 // BE CAUTIOUS: this file is a fork of 'qv-sec-property-header.jst' 
__p+='\n';
 let { property, lotunitslabel, is_mobile, isSaveable, listingId, isLoggedIn, resId, placeholder, propertyStatus, pageType, bathsString, isPlan, car_icon, calc_icon, ab_promo, isSpecHome } = options; 
__p+='\n\n';
 let addressUnavailable = property.address_display === 'Address Not Available' || (property.flags && property.flags.is_address_suppressed),
       noAddressMeta      = !property.city && !property.state_code && !property.postal_code; 
__p+='\n\n';
 let { address, city, state_code, postal_code, full_address_display } = property; 
__p+='\n\n';
 if (ab_promo) { 
__p+='\n  '+
((__t=( JST["quick_view/templates/optimization/enhanced-label"]({ is_mobile }) ))==null?'':__t)+
'\n';
 } 
__p+='\n\n';
 let qvldp_mweb_txt_class    = MOVE_DATA.media_qvldp_mweb_txt_class 
__p+='\n';
 let media_qvldp_mweb_txt_ad = MOVE_DATA.media_qvldp_mweb_txt_ad 
__p+='\n\n<div class="qv-property-header ab-v3 graphical-uplift">\n  <div class="row row-ad">\n    <div class="col-qv-xs-12 col-qv-sm-12 ad-text-dart">\n      ';
 if(!is_mobile && !placeholder) { 
__p+='\n        <span id="div-gpt-ad-TXTLDP1B" class="ad-quick-view-preload TXTLDPLoading"></span>\n        <span id="div-gpt-ad-TXTLDP1" class="ad-quick-view-preload TXTLDPLoading"></span>\n      ';
 } 
__p+='\n    </div>\n  </div>\n  <div class="row main-info">\n    <div class="col-qv-xs-12 col-qv-sm-7 col-qv-md-12 col-qv-lg-7 qv-price-wrapper">\n      ';
 if(property.price_display) { 
__p+='\n          <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" itemid="#offer" class="price">\n              <span itemprop="price" content="'+
((__t=( property.price ))==null?'':__t)+
'">\n                ';
 if(property.price_display){ 
__p+='\n                  ';
 if(property.property_type == "new_plan") { 
__p+=' <span class="font-size-base font-normal">from</span> ';
 } 
__p+='\n                  '+
((__t=( property.price_display ))==null?'':__t)+
'\n                  ';
 if(property.flags && property.flags.is_price_reduced && !MOVE_DATA.ab_hlt_price_drop === "V1") { 
__p+=' <i class="ra ra-arrow-down icon-reduce-price color-green"></i> ';
 } 
__p+='\n                ';
 } 
__p+='\n              </span>\n              <meta itemprop="priceCurrency" content="USD">\n              <link itemprop="businessFunction" href="http://purl.orgorg/goodrelations/v1#Sell">\n              <meta itemprop="category" content="Real Estate > '+
((__t=( property.status_display ))==null?'':__t)+
'">\n          </div>\n          <a id="estimate-payment-link" class="estimate-payment-link graphical-uplift js-hide-ajax-fail" open-payment-modal href="#" data-omtag="'+
((__t=( propertyStatus == 'new_community' ? 'ready_to_biuld' : propertyStatus   +':'+ pageType))==null?'':__t)+
':propInfo:estimatePayment">\n            <img class="calc-icon" src="'+
((__t=( calc_icon ))==null?'':__t)+
'" >\n            Estimate mortgage\n          </a>\n          ';
 if(property.flags && property.flags.is_price_reduced && property.price_history && property.price_history.length > 0) { 
__p+='<div class="qv-property-header-reduced font-size-base"><i class="ra ra-arrow-down icon-reduce-price color-green"></i> Reduced from '+
((__t=( property.price_history[1].price_display ))==null?'':__t)+
'</div> ';
 } 
__p+='\n        ';
 } 
__p+='\n    </div>\n\n    <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7">\n      ';
 if (property.beds || property.baths ||property.sqft_display || property.lot_size_display) { 
__p+='\n        <ul class="property-meta graphical-uplift list-horizontal list-unstyled">\n          ';
 if(property.beds) { 
__p+='\n            <li>\n              <span class="font-bold">'+
((__t=( property.beds ))==null?'':__t)+
'</span>\n                bed\n            </li>\n          ';
 } 
__p+='\n          ';
 if(Boolean(bathsString)) { 
__p+='\n            <li><span class="font-bold">'+
((__t=( bathsString[0] ))==null?'':__t)+
'</span> '+
((__t=( bathsString[1] ))==null?'':__t)+
'</li>\n          ';
 } 
__p+='\n          ';
 if(property.sqft_display) { 
__p+='\n            <li>\n                <span class="font-bold">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sqft\n            </li>\n          ';
 } 
__p+='\n          ';
 if(property.lot_size_display) { 
__p+='\n            <li>\n                <span class="font-bold">'+
((__t=( property.lot_size_display ))==null?'':__t)+
'</span>  '+
((__t=( lotunitslabel ))==null?'':__t)+
'\n            </li>\n          ';
 } 
__p+='\n        </ul>\n      ';
 } 
__p+='\n      ';
 if(is_mobile) { 
__p+='\n        <div class="clearfix visible-qv-xs-block '+
((__t=( qvldp_mweb_txt_class ))==null?'':__t)+
'">\n          ';
 if (media_qvldp_mweb_txt_ad === "v2") { 
__p+='\n            <div id="div-gpt-ad-TXTLDP1B" class="ab-txt-ldp1b ad-quick-view-preload ad-quick-view-mobile-top TXTLDPLoading"></div>\n          ';
 } 
__p+='\n        </div>\n      ';
 } 
__p+='\n      ';
 if (property.building && property.building.permalink) { 
__p+='\n        <div class="building-link">\n          <a href="'+
((__t=( `/realestateandhomes-detail/${property.building.permalink}` ))==null?'':__t)+
'" target="_blank">\n            See all units in this building\n          </a>\n        </div>\n      ';
 } 
__p+='\n    </div>\n\n        ';
 if (!isPlan) { 
__p+='\n      <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7 key-info">\n        <h2 class="address">\n          '+
((__t=( JST['quick_view/templates/qv-subsec-property-header-address-ab-v3']({
            addressUnavailable,
            noAddressMeta,
            address,
            city,
            state_code,
            postal_code,
            full_address_display }) ))==null?'':__t)+
'\n        </h2>\n      </div>\n      <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7 key-info commute-time-wrapper graphical-uplift">\n        <div id="ldp-commute-time" class="qv-commute ldp-commute-time">\n          <img class="ldp-commute-icon" src="'+
((__t=( car_icon ))==null?'':__t)+
'" >\n          <a rel="popover" href="javascript:void(0)" class="estimate-commute-popover-toggle font-size-base">Commute time</a>\n        </div>\n        <div id="qv-commute-wrapper"></div>\n      </div>\n    ';
 } 
__p+='\n\n    ';
 if (isPlan) { 
__p+='\n      <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7 plan-name">\n        <h2>'+
((__t=( property.name ))==null?'':__t)+
''+
((__t=( property.name && property.name.toLowerCase().includes("plan") ? "" : " Plan" ))==null?'':__t)+
'\n          <span><a href="'+
((__t=( property.new_community && property.new_community.community_url ))==null?'':__t)+
'">'+
((__t=( property.community_complete_title ))==null?'':__t)+
' Community</a></span>\n        </h2>\n      </div>\n      <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7 key-info">\n        <h2 class="address sales-office">Sales Office: \n          '+
((__t=( JST['quick_view/templates/qv-subsec-property-header-address-ab-v3']({
            addressUnavailable,
            noAddressMeta,
            address,
            city,
            state_code,
            postal_code,
            full_address_display }) ))==null?'':__t)+
'\n        </h2>\n      </div>\n      <div class="col-qv-xs-9 col-qv-sm-7 col-qv-md-9 col-qv-lg-7 key-info commute-time-wrapper graphical-uplift">\n        <div id="ldp-commute-time" class="qv-commute ldp-commute-time">\n          <img class="ldp-commute-icon" src="'+
((__t=( car_icon ))==null?'':__t)+
'" >\n          <a rel="popover" href="javascript:void(0)" class="estimate-commute-popover-toggle font-size-base">Commute time</a>\n        </div>\n        <div id="qv-commute-wrapper"></div>\n      </div>\n    ';
 } 
__p+='\n\n    <div class="col-qv-xs-3 col-qv-md-3 map-btn-sm">\n      <div class="clearfix">\n        <div class="map-cta-wrapper js-hide-ajax-fail">\n          <a href="javascript:void(0)" class="map-btn hidden-qv-sm hidden-qv-lg" id="qv-map-cta" data-omtag="ldp:photogallery:map">\n            <img src="data:image/png;base64,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" alt="Quickview">\n            <div class="copy">\n              <i class="ra ra-map-marker ra-lg"></i>\n              <span>Map</span>\n            </div>\n          </a>\n        </div>\n     \n      </div>\n    </div>\n  </div>\n\n  ';
 if (isSaveable !== undefined && listingId && !isSpecHome) { 
__p+='\n    <a href="javascript:void(0)" data-omtag="'+
((__t=( propertyStatus == 'new_community' ? 'ready_to_biuld' : propertyStatus  ))==null?'':__t)+
':ldp-quickview:sticky-top:listing_save" class="js-hide-ajax-fail qv-favorite qv-photo-save ';
 if (isLoggedIn) { 
__p+='qv-';
 if (isSaveable) { 
__p+='un';
 } 
__p+='save';
 } else { 
__p+='qv-save-not-logged-in';
 } 
__p+='" aria-label="save listing from header" data-listingid="'+
((__t=( listingId ))==null?'':__t)+
'" ';
 if (isSaveable) { 
__p+='data-res-id="'+
((__t=( resId ))==null?'':__t)+
'"';
 } 
__p+='>\n      <i class="ra ra-heart';
 if (!isSaveable) { 
__p+='-o';
 } 
__p+='"></i>\n    </a>\n  ';
 } 
__p+='\n\n  ';
 if (placeholder) {
__p+='\n    <a class="js-hide-ajax-fail qv-favorite qv-photo-save qv-save-not-logged-in" aria-label="save listing">\n      <i class="ra ra-heart-o"></i>\n    </a>\n  ';
 } 
__p+='\n</div>\n\n';
 if (property.status_display_below_hero_image && false) { 
__p+='\n <div class="col-qv-sm-4">\n    <span><i class="ra ra-bc-house-for-sale icon-space-right color-red"></i>\n      '+
((__t=( property.status_display_below_hero_image ))==null?'':__t)+
'\n      ';
 if (property.property_type === 'for_sale' &&
              !property.flags.is_pending &&
              !property.flags.is_contingent &&
              property.property_status_display &&
              property.property_type != "new_plan") { 
__p+='\n      <span>\n        <span class="padding-left-sm padding-right-sm"> - </span>\n        <span data-label="property-meta-active">'+
((__t=( property.property_status_display ))==null?'':__t)+
'</span>\n      </span>\n    ';
 } 
__p+='\n    </span>\n  </div>\n';
 } 
__p+='\n\n';
 if(is_mobile) { 
__p+='\n  <div class="clearfix visible-qv-xs-block '+
((__t=( qvldp_mweb_txt_class ))==null?'':__t)+
'">\n    ';
 if (!placeholder) {
__p+='\n      ';
 if (media_qvldp_mweb_txt_ad === "v1") { 
__p+='\n        <div id="div-gpt-ad-TXTLDP1B" class="ab-txt-ldp1b ad-quick-view-preload ad-quick-view-mobile-top TXTLDPLoading"></div>\n      ';
 } 
__p+='\n      <div id="div-gpt-ad-TXTLDP1" class="ab-txt-ldp1 ad-quick-view-preload ad-quick-view-mobile-top TXTLDPLoading"></div>\n    ';
 } 
__p+='  \n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-property-header-ab-v3-graphical-uplift.jst.ejs